/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wc_Tut_Ui_RefsInputs */

const en_wc_tut_ui_refs = /** @type {(inputs: Wc_Tut_Ui_RefsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`References and Mailings: TOC, footnotes, citations, mail merge, envelopes.`)
};

/**
* | output |
* | --- |
* | "References and Mailings: TOC, footnotes, citations, mail merge, envelopes." |
*
* @param {Wc_Tut_Ui_RefsInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const wc_tut_ui_refs = /** @type {((inputs?: Wc_Tut_Ui_RefsInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wc_Tut_Ui_RefsInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_wc_tut_ui_refs(inputs)
});
export { wc_tut_ui_refs as "wc.tut.ui.refs" }